export default __webpack_public_path__ + "static/media/live-icon-active.c0ea16cd.webp";